import script from "./Map.vue?vue&type=script&setup=true&lang=js"
export * from "./Map.vue?vue&type=script&setup=true&lang=js"

export default script